import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import useSubjectAddressParams from '@UI/Pages/Beneficiaries/Hooks/Params/useSubjectAddressParams';
import useStrictCurrentFacility from '@UI/Providers/CurrentFacilityProvider/useStrictCurrentFacility';
import { useParams } from 'react-router-dom';

type RouteParams = {
	readonly document: string;
};

export type DocumentRouteIds = {
	readonly facilityId: number;
	readonly subject: SubjectAddress;
	readonly documentId: number;
};

/**
 * Resolves the three route-carried identifiers a verification gesture's Command needs. `index.tsx`
 * already redirects away before mounting `DocumentDetailsContent` when either segment fails to parse
 * — every reader below that guard, this one included, can assume a valid dossier address and document id.
 */
const useDocumentRoute = (): DocumentRouteIds => {
	const { currentFacility } = useStrictCurrentFacility();
	const { subject } = useSubjectAddressParams();
	const params = useParams<RouteParams>();

	if (subject === null) {
		throw new Error('The document route has no valid dossier address.');
	}

	return {
		facilityId: currentFacility.id,
		subject,
		documentId: Number(params.document),
	};
};

export default useDocumentRoute;
